import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCol,
    IonIcon,
    IonLabel,
    IonRow,
    IonText,
    isPlatform,
} from "@ionic/react";
import React from "react";
import { add } from "ionicons/icons";
import { Event } from "../../models";
import { useHistory } from "react-router";

interface _Props {
    event: Event
}

const AddEventClassCard: React.FC<_Props> = ({event}) => {
    const history = useHistory();

    const navigateToPage = () => {
        if (event) {
            const path = "/index/staff/event/" + event.id + "/class/new";
            history.replace(path);
        }
    }

    return (
        <>
            {isPlatform("mobile") ? 
                <IonButton expand="full" onClick={navigateToPage}>
                    <IonIcon icon={add} size="large" />
                    <IonText>Add Class</IonText>
                </IonButton>
                :
                <IonButton onClick={navigateToPage}>
                    <IonIcon icon={add} size="large" />
                    <IonText>Add Class</IonText>
                </IonButton>
            }
        </>
    );
};

export default AddEventClassCard;
